import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "responsible-stay-card d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3 p-3 bg-white border border-primary-green rounded-custom" }
const _hoisted_3 = {
  class: "desktop-icon d-none d-md-flex justify-content-center align-items-center rounded-circle bg-green-200",
  style: {"min-width":"71px","height":"71px"}
}
const _hoisted_4 = {
  class: "d-icon",
  style: {"color":"var(--primary-green)"}
}
const _hoisted_5 = { class: "content-wrapper d-flex flex-column align-items-start gap-2 text-md-left" }
const _hoisted_6 = { class: "d-flex align-items-center gap-2" }
const _hoisted_7 = {
  class: "mobile-icon d-flex d-md-none justify-content-center align-items-center rounded-circle bg-green-200",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_8 = {
  class: "m-icon",
  style: {"color":"var(--primary-green)"}
}
const _hoisted_9 = { class: "title-4 text-primary-green mb-0" }
const _hoisted_10 = { class: "body m-0" }

import { ref, watch } from 'vue'
  import EcoPopup from '@/vue/responsible-stay/components/EcoPopup.vue'
  import { CriteriaEnum } from '@/enums/criterias'

  interface IResponsibleStay {
    stationData: Record<string, any>
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ResponsibleStay',
  props: {
    stationData: {}
  },
  setup(__props: any) {

  const props = __props

  const content = ref<{ [key: string]: string }>(window.content)
  const isCriteriaFloconVert = ref(false)
  const isCriteriaCleVerte = ref(false)
  const isPopupOpen = ref(false)

  const checkCriteria = (): void => {
    if (props.stationData?.criterias) {
      isCriteriaFloconVert.value = props.stationData.criterias.includes(
        CriteriaEnum.FLOCON_VERT
      )
    }
    if (window.lihe?.criteriasList) {
      isCriteriaCleVerte.value = window.lihe.criteriasList.includes(
        CriteriaEnum.CLE_VERTE
      )
    }
  }

  watch(
    () => props.stationData?.criterias,
    newCriterias => {
      if (newCriterias) {
        checkCriteria()
      }
    }
  )

  const togglePopup = () => {
    isPopupOpen.value = !isPopupOpen.value
  }

  const closePopup = () => {
    isPopupOpen.value = false
  }

return (_ctx: any,_cache: any) => {
  return (isCriteriaFloconVert.value || isCriteriaCleVerte.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[0] || (_cache[0] = [
              _createElementVNode("use", { "xlink:href": "#___icon___responsible" }, null, -1)
            ])))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[1] || (_cache[1] = [
                  _createElementVNode("use", { "xlink:href": "#___icon___responsible" }, null, -1)
                ])))
              ]),
              _createElementVNode("strong", _hoisted_9, _toDisplayString(content.value.responsible_stay), 1)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(content.value.responsible_stay_hover), 1)
          ]),
          _createElementVNode("button", {
            class: "button-secondary-small ms-auto",
            onClick: _withModifiers(togglePopup, ["stop"])
          }, _toDisplayString(content.value.productDesc_seeMore), 1)
        ]),
        _createVNode(EcoPopup, {
          isOpen: isPopupOpen.value,
          title: content.value.responsible_stay,
          isCriteriaFloconVert: isCriteriaFloconVert.value,
          isCriteriaCleVerte: isCriteriaCleVerte.value,
          onClose: closePopup
        }, null, 8, ["isOpen", "title", "isCriteriaFloconVert", "isCriteriaCleVerte"])
      ]))
    : _createCommentVNode("", true)
}
}

})